<div class="main-wrap">
  <p>
    Online Courses
  </p>
  <div class="button-container">
    <div class="add-button-wrap">
      <p-button label="Add School" routerLink="/management/create-online-course"></p-button>
    </div>
    <div class="search-box">
      <div class="ui-inputgroup">
        <input pInputText  placeholder="search term here" type="text" [(ngModel)]="searchTerm">
        <span class="ui-inputgroup-addon"><i class="pi pi-search" style="line-height: 1.25;"></i></span>
      </div>
    </div>
  </div>
  <div class="table-wrap">
    <p-table selectionMode="single" [value]="schools | jsonFilter:[searchTerm, searchOption]">
      <ng-template pTemplate="header">
        <tr>
          <th id="id-head">ID</th>
          <th>Name</th>
          <th>Created By</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-school>
        <tr [pSelectableRow]="school" (click)="editSchool(school.id)">
          <td>
            {{school.id}}
          </td>
          <td>
            {{school.name}}
          </td>
          <td>
            <span  *ngIf="school.createdBy">
              {{school.createdBy.name}}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>